// Keep "You've viewed X/Y products" consistent with what is actually visible after client-side post-filters hide cards.
// This is intentionally small + defensive because other scripts may overwrite the counter.
(() => {
  if (window.__btos_collection_counts_fix__) return;
  window.__btos_collection_counts_fix__ = true;

  const isVisible = (el) => {
    if (!el) return false;
    const cs = window.getComputedStyle(el);
    return !!cs && cs.display !== 'none' && cs.visibility !== 'hidden';
  };

  const shouldAdjustTotals = (root) => {
    // Only adjust totals when we know client-side hiding is in play (avoid fighting Shopify's native counts).
    if (root.querySelector('.product-item[data-btos-size-hidden="true"], .product-item[data-btos-shoe-size-hidden="true"]')) return true;
    const qs = (root.defaultView || window).location?.search || location.search || '';
    return /filter\.v\./i.test(qs) && /(size|shoe|helmet|waist|inseam|length)/i.test(qs);
  };

  const patchTotals = (root = document) => {
    if (!shouldAdjustTotals(root)) return;

    const wrap = root.querySelector('.current-prods') || document.querySelector('.current-prods');
    // Note: `.current-prods` exists near the grid; `.total-count` exists in the header row above filters/sort.

    const items = Array.from((root.querySelectorAll('.product-item') || document.querySelectorAll('.product-item')));
    const visibleCount = items.filter(isVisible).length;

    // 1) Update header total count (e.g. "3 Items (1 filter applied)") to reflect visibleCount.
    const headerTotal = root.querySelector('.collection-utils .total-count') || document.querySelector('.collection-utils .total-count');
    if (headerTotal) {
      // Preserve any "(n filter applied)" child nodes by only updating the first text node.
      const label = `${visibleCount} ${visibleCount === 1 ? 'Item' : 'Items'}`;
      let updated = false;
      headerTotal.childNodes.forEach((node) => {
        if (updated) return;
        if (node.nodeType === Node.TEXT_NODE) {
          node.textContent = label + ' ';
          updated = true;
        }
      });
      if (!updated) {
        // If structure is different, just set textContent (best-effort).
        headerTotal.textContent = label;
      }
    }

    // 2) Update "You've viewed X/Y products" total (Y) near the grid.
    if (!wrap) return;

    const currentEl = wrap.querySelector('.currentTotal') || document.querySelector('.currentTotal');
    const totalEl = wrap.querySelector('.totalCount') || document.querySelector('.totalCount');

    // Only update the total (Y). X is treated as a progress counter elsewhere.
    if (totalEl) {
      totalEl.textContent = String(visibleCount);
    } else {
      // Fallback: rewrite text nodes in the wrapper containing "/<number> products"
      wrap.childNodes.forEach((node) => {
        if (node.nodeType !== Node.TEXT_NODE) return;
        node.textContent = node.textContent.replace(/\/\s*\d+\s*products/i, `/${visibleCount} products`);
      });
    }

    // Clamp X if it somehow exceeds the visible total.
    if (currentEl) {
      const curr = parseInt((currentEl.textContent || '').trim(), 10);
      if (!Number.isNaN(curr) && curr > visibleCount) currentEl.textContent = String(visibleCount);
    }
  };

  const attach = (pm) => {
    if (!pm || pm.__btosCountsFixAttached) return;
    pm.__btosCountsFixAttached = true;

    const run = () => patchTotals(document);
    pm.addEventListener('pageLoaded', () => setTimeout(run, 0));

    // Watch for other scripts overwriting the counter or toggling display styles.
    const gridSel = pm?.dataset?.itemsContainerSelector;
    const grid = gridSel ? document.querySelector(gridSel) : pm.querySelector('.collection-grid');
    if (grid) {
      const mo = new MutationObserver(() => patchTotals(document));
      mo.observe(grid, { attributes: true, childList: true, subtree: true, attributeFilter: ['style', 'class', 'data-btos-size-hidden', 'data-btos-shoe-size-hidden'] });
    }

    // Also watch the header count area since filter AJAX swaps can replace it.
    const headerWrap = pm.querySelector('.page-top-wrap') || document.querySelector('.page-top-wrap');
    if (headerWrap) {
      const mo2 = new MutationObserver(() => patchTotals(document));
      mo2.observe(headerWrap, { childList: true, subtree: true });
    }
  };

  const attachAll = () => document.querySelectorAll('page-manager').forEach(attach);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      attachAll();
      patchTotals(document);
    });
  } else {
    attachAll();
    patchTotals(document);
  }

  // Keep attaching after ajax swaps.
  const pageMo = new MutationObserver(() => attachAll());
  pageMo.observe(document.documentElement, { childList: true, subtree: true });
})();


